import Underline from '@tiptap/extension-underline';

// Matches `<u>` and inline `<span>` elements that carry text-decoration:
// underline. Intentionally avoids ProseMirror's `style:` matcher form,
// which (with `consuming: false`) cascades the underline mark to every
// descendant text node of any element bearing the inline style — so a
// pasted block-level wrapper with text-decoration leaks underline onto
// unrelated paragraphs/lists.
export const UnderlineExtended = Underline.extend({
  parseHTML() {
    return [
      {
        tag: 'u',
      },
      {
        tag: 'span',
        getAttrs: (element: HTMLElement) => {
          const style = element.getAttribute('style');
          return style && style.includes('text-decoration: underline') ? {} : false;
        },
      },
      {
        tag: 'span',
        getAttrs: (element: HTMLElement) => {
          return element.style.textDecoration &&
            element.style.textDecoration.includes('underline')
            ? {}
            : false;
        },
      },
    ];
  },
  priority: 1000,
});
